const isFunctionType = (type) => {
  return typeof type === 'function'
}

const isBooleanType = (type) => {
  return typeof type === 'boolean'
}

export { isFunctionType, isBooleanType }
